import ReportsCellView from "app/pages/reports-and-analytics/components/reports/ReportsCellView";
import { mapTransportationModeToMode } from "app/pages/reports-and-analytics/components/reports/ReportsTabContainer";
import { ReportRow } from "app/pages/reports-and-analytics/types/client";
import CursorPaginationTableControlsView from "components/pagination/CursorPaginationTableControlsView";
import ScrollableView from "components/ScrollableView";
import TableView, { TableViewColumns } from "components/TableView";
import withAsync from "components/withAsync";

import { useGetBrokerReportQuery } from "../api/brokerInsightsApi";
import { useBrokerInsightsIndexSliceSelector } from "../store/brokerInsightsIndexStore";

const BrokerInsightsIndexTableContainer = withAsync({
  useHook: () => {
    const { selectedReport, mode, searchQuery, fromDate, toDate } = useBrokerInsightsIndexSliceSelector(
      (state) => state.brokerInsightsIndexFilterSlice
    );

    // Fetch data conditionally
    return useGetBrokerReportQuery({
      urlParams: { id: selectedReport?.id ?? 1001 },
      queryParams: {
        mode: mapTransportationModeToMode[mode],
        search: searchQuery,
        from: fromDate,
        to: toDate,
      },
    });
  },
  Component: ({
    loadedData: {
      paginationOptions,
      data: { data: report },
      isFetching,
      isLoading,
    },
  }) => {
    const columns: TableViewColumns<ReportRow> = report.columns.map((column) => ({
      name: column.name,
      renderCell: (row) => <ReportsCellView row={row} column={column} />,
      headerCellProps: { style: { whiteSpace: "nowrap" } },
      cellProps: { style: { whiteSpace: "nowrap" } },
    }));

    return (
      <>
        <ScrollableView>
          <TableView columns={columns} items={report.rows} isLoading={isFetching || isLoading} />
        </ScrollableView>
        <CursorPaginationTableControlsView {...paginationOptions} />
      </>
    );
  },
});

export default BrokerInsightsIndexTableContainer;
